import CategorySelector from './CategorySelector.jsx';

export default CategorySelector;


// WEBPACK FOOTER //
// ./src/components/CategorySelector/index.jsx